<template src="./Details.html"></template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("employeeLeaves/getDetails", this.itemId)
            .then(() => {

            })
            .catch(() => { });
    },
    computed: {
        leave() {
            return this.$store.state.employeeLeaves.leave;
        }
    },
    methods: {

        download() {
            window.open(
                `/api/employeeLeaves/${this.leave.attachmentId}/attachment`,
                "_blank"
            );
        }
    },
};
</script>